jQuery(document).ready(function () {
    animateGallery();

    jQuery(".mod-gallery .gallery-main").each(function () {
        if (jQuery(this).find(".gallery-slider > div").length > 1) {
            jQuery(this).find(".gallery-slider").slick({
                dots: false,
                infinite: true,
                arrows: true,
                prevArrow: jQuery(this).parent().find(".slick-controls .arrow-prev"),
                nextArrow: jQuery(this).parent().find(".slick-controls .arrow-next"),
            });
        }
    });
})

jQuery(window).on("scroll", function () {
    animateGallery();
})

function animateGallery() {
    if (jQuery(".mod-gallery .gallery-main").length > 0) {
        jQuery(".mod-gallery .gallery-main").each(function () {
            if ((jQuery(window).scrollTop() + jQuery(window).height() * 0.2) > jQuery(this).offset().top) {
                jQuery(this).find(".gallery-slider-item").addClass("animate");
                var item1 = this;
                setTimeout(() => {
                    jQuery(item1).addClass("parent-animate");
                }, 1000);
            }
        })
    }
}